export default __webpack_public_path__ + "static/2-10c3c1dffdecc4028cbc72b20ee796e4.jpeg";